import { LanguageSelector } from "@components/LanguageSelector";
import React from "react";

export const LanguageConfiguration = () => {
  return <LanguageSelector />;
};
